import PropTypes from 'prop-types'

import {
  Box, Button, Form, Line, SidebarModal,
} from '@domain-group/suit-theme'

import usePublication, { usePublicationForm } from '@hooks/usePublication'

import EntitySelector from '@components/EntitySelector'

const CreatePublicationModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { createPublication } = callbacks

  const {
    callbacks: { createPublication: createFn },
    creating,
  } = usePublication()

  const {
    entityState,
    entityState: {
      provider_id,
      title,
    },
    errors,
    handlers,
    saveEnabled,
    setEntityState,
  } = usePublicationForm({}, { validateOn: 'change' })

  const publicationPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Publication Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Publication" />

      <SidebarModal.Content>
        <Box flexDirection="column" flexShrink={0}>
          <EntitySelector
            callbacks={{
              selectItem: provider => setEntityState({ provider_id: provider ? provider.id : null }),
            }}
            entityKey="providers"
            errorMessage={errors.provider_id}
            label="Assign to Provider"
            searchRequestOptions={{ publication_providers: true }}
            selectedItemId={provider_id}
          />

          {provider_id && (
            <>
              <Line />

              <Form>
                <Form.Field errorMessage={errors.title} label="* Title">
                  <input name="title" value={title} type="text" {...handlers} />
                </Form.Field>
              </Form>
            </>
          )}

        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createPublication(publicationPayload)}
          size="large"
        >
          {saveEnabled ? 'Create Publication' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreatePublicationModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

CreatePublicationModal.defaultProps = {
  modalKey: 'CreatePublicationModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreatePublicationModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
